<template>
  <div class="order-expartiate">
    <!--        <el-tabs v-model="activeName" type="border-card">-->
    <!--            <el-tab-pane label="全部" name="all">-->
    <div class="title flex-between">
      <div>
        <el-input
          :placeholder="$lange == 'en' ? 'Order ID' : '订单号'"
          size="mini"
          v-model="tableParams.id"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <!-- <div>
        <el-input
          :placeholder="$lange == 'en' ? 'Request No.' : '请输入服务号'"
          size="mini"
          v-model="tableParams.workOrderId"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div> -->
      <div>
        <el-input placeholder="Job ID" size="mini" v-model="tableParams.jobId">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div>
        <el-input
          :placeholder="$lange == 'en' ? 'Customer Name' : '公司'"
          size="mini"
          v-model="tableParams.customerName"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div>
        <!-- <el-input
          :placeholder="this.$lange == 'en' ? 'Responsible' : '处理人'"
          size="mini"
          v-model="tableParams.handlerName"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input> -->
        <el-select
          v-model="tableParams.handlerId"
          size="mini"
          :placeholder="this.$lange == 'en' ? 'Responsible' : '处理人'"
          clearable
        >
          <el-option
            v-for="(itmem, index) in user"
            :label="itmem.name"
            :value="itmem.id"
          ></el-option>
        </el-select>
      </div>
      <div>
        <el-select
          v-model="tableParams.status"
          size="mini"
          :placeholder="$lange == 'en' ? 'Status' : '选择状态'"
          clearable
        >
          <!-- <el-option
            :label="item"
            :value="index"
            v-for="(item, index) in expartiateStatus"
          ></el-option> -->
          <el-option
            v-if="index > 0"
            v-for="(items, index) in status"
            :label="$lange == 'en' ? items.label : items.label"
            :value="items.value"
          ></el-option>
        </el-select>
      </div>
      <div>
        <el-date-picker
          size="mini"
          v-model="seletcTime"
          type="datetimerange"
          range-separator="至"
          value-format="yyyy-MM-dd HH:mm:ss"
          :defaultTime="['00:00:00', '23:59:59']"
          :start-placeholder="$lange == 'en' ? 'StartTime' : '开始日期'"
          :end-placeholder="$lange == 'en' ? 'EndTime' : '结束日期'"
          @change="timeChange"
          style="width: 350px"
        >
        </el-date-picker>
      </div>
      <!-- <el-button type="primary" size="mini" @click="search">{{
        $lange == "en" ? "Search" : "搜索"
      }}</el-button> -->
      <el-button type="primary" size="mini" @click="exportData">{{
        $lange == "en" ? "Exporting search results" : "导出搜索结果"
      }}</el-button>
    </div>
    <div class="content">
      <cc-table
        :config="tableConfig"
        :params="tableParams"
        :refesh-params="referTable"
      ></cc-table>
    </div>
    <!--            </el-tab-pane>-->
    <!--            <el-tab-pane label="我的" name="me">-->
    <!--                <div class="title flex-between">-->
    <!--                    <div>-->
    <!--                        <el-input placeholder="JobId" size="mini" v-model="tableParams.jobId"></el-input>-->
    <!--                    </div>-->
    <!--                    <div>-->
    <!--                        <el-select v-model="tableParams.status" size="mini" placeholder="选择状态">-->
    <!--                            <el-option :label="item" :value="index" v-for="(item, index) in expartiateStatus"></el-option>-->
    <!--                        </el-select>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--                <div class="content">-->
    <!--                    <cc-table-->
    <!--                            :config="tableConfig"-->
    <!--                            :params="tableParamsMe"-->
    <!--                    >-->

    <!--                    </cc-table>-->
    <!--                </div>-->
    <!--            </el-tab-pane>-->
    <!--        </el-tabs>-->

    <el-dialog
      :visible.sync="detailsDialog"
      :fullscreen="true"
      :title="$lange == 'en' ? 'Details' : '详情'"
      @closed="dialogClose"
    >
      <template v-if="detailsDialog">
        <ExpartiateDescriptionViewV2
          :id="detailsId"
          :isDialog="true"
        ></ExpartiateDescriptionViewV2>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import ExpartiateDescriptionView from "./ExpartiateDescription";
import ExpartiateDescriptionViewV2 from "./ExpartiateDescriptionViewV2";

export default {
  name: "OrderExpartiate",
  props: {},
  data() {
    return {
      detailsId: "",
      isEditV2: false,
      detailsDialog: false,
      activeName: "all",
      status: [
        {
          label: "草稿",
          value: 0,
        },
        {
          label: this.$lange == "en" ? "New" : "新申请",
          value: 1,
        },
        {
          label: this.$lange == "en" ? "Customer Action" : "待客户确认",
          value: 2,
        },
        {
          label: this.$lange == "en" ? "Waiting Approval" : "待审批",
          value: 3,
        },
        {
          label: this.$lange == "en" ? "Engineer Preparing" : "等待派工",
          value: 4,
        },
        {
          label: this.$lange == "en" ? "On working" : "服务中",
          value: 5,
        },
        {
          label: this.$lange == "en" ? "Completed" : "已完成",
          value: 6,
        },
        {
          label: this.$lange == "en" ? "Close" : "已关闭",
          value: 7,
        },
        {
          label: this.$lange == "en" ? "Cancel" : "已取消",
          value: 8,
        },
      ],
      expartiateStatus:
        this.$lange == "en"
          ? [
              "To make an appointment",
              "To be appointed",
              "To be audited",
              "Approved",
              "Audit rejected",
              "Attachment / report uploaded",
            ]
          : [
              "待预约",
              "待指派",
              "待审批",
              "审核通过",
              "审核拒绝",
              "已上传附件/报告",
            ],
      tableConfig: {
        api: "admin/fsb/expatriate/queryByPlan",
        showPager: true,
        columns: [
          {
            prop: "expatriateOrder.id",
            // prop: "expatriateOrder.workOrderId",
            lable: this.$lange == "en" ? "Order No." : "订单号",
            minWidth: 110,
          },
          {
            prop: "expatriateOrder.status",
            lable: this.$lange == "en" ? "Status" : "订单状态",
            minWidth: this.$lange == "en" ? 140 : 110,
            type: "tag",
            options: [
              {
                tagType: "info",
                text: "草稿",
              },
              {
                tagType: "info",
                text: this.$lange == "en" ? "New" : "新申请",
              },
              {
                tagType: "Blue",
                text: this.$lange == "en" ? "Customer Action" : "待客户确认",
              },
              {
                tagType: "info",
                text: this.$lange == "en" ? "Waiting Approval" : "待审批",
              },
              {
                tagType: "Blue",
                text: this.$lange == "en" ? "Engineer Preparing" : "等待派工",
              },
              {
                tagType: "Blue",
                text: this.$lange == "en" ? "On working" : "服务中",
              },
              {
                tagType: "success",
                text: this.$lange == "en" ? "Completed" : "已完成",
              },
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Close" : "已关闭",
              },
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Cancel" : "已取消",
              },
            ],
            // render: (e) => {
            //   if (e.expatriateOrder) {
            //     return type[e.expatriateOrder.status].label;
            //   }
            // },
          },
          {
            prop: "expatriateOrder.workOrder.jobId",
            lable: this.$lange == "en" ? "Job ID" : "Job ID",
            minWidth: 110,
          },
          {
            prop: "employeeType",
            lable: this.$lange == "en" ? "engineer Type" : "工程师类别",
            minWidth: 110,
            render: (row) => {
              // return ["机械工程师", "电气工程师", "软件工程师", "质量工程师"][
              //   row.employeeType
              // ];
              if (this.$lange == "en") {
                return ["Mechanic", "Electrical", "Software", "Quality"][
                  row.employeeType
                ];
              } else {
                return ["机械工程师", "电气工程师", "软件工程师", "质量工程师"][
                  row.employeeType
                ];
              }
            },
          },
          {
            prop: "num",
            lable: this.$lange == "en" ? "Quantity" : "数量",
          },
          {
            prop: "preWorkHour",
            lable: this.$lange == "en" ? "Plan Working Hours" : "计划总工时",
            minWidth: 80,
          },
          {
            prop: "expatriateOrder.feeType",
            lable: this.$lange == "en" ? "Cost Type" : "费用类型",
            minWidth: 80,
            // render: (row) => {
            //   // return ["保内", "保外"][row.expatriateOrder.feeType];
            //   if (this.$lange != "en") {
            //     return ["保内", "保外"][row.expatriateOrder.feeType];
            //   } else {
            //     return ["Free", "Paid"][row.expatriateOrder.feeType];
            //   }
            // },
            type: "tag",
            options: [
              {
                tagType: "info",
                text: this.$lange == "en" ? "Free" : "保内",
              },
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Paid" : "保外",
              },
            ],
          },
          {
            prop: "expatriateOrder.handlerName",
            lable: this.$lange == "en" ? "Responsible" : "处理人",
            minWidth: 100,
          },
          {
            prop: "startTime",
            lable: this.$lange == "en" ? "Scheduled to go" : "计划开始",
            minWidth: 100,
            render: (row) => {
              if (row.startTime) {
                return moment(row.startTime).format("YYYY-MM-DD");
              }
              return "";
            },
          },
          // {
          //   prop: "endTime",
          //   lable: this.$lange == "en" ? "Scheduled to" : "计划结束",
          //   minWidth: 100,
          //   render: (row) => {
          //     return moment(row.endTime).format("YYYY-MM-DD");
          //   },
          // },
          {
            prop: "relStartTime",
            lable: this.$lange == "en" ? "Actual Start" : "实际开始",
            minWidth: 100,
            render: (row) => {
              if (row.relStartTime) {
                return moment(row.relStartTime).format("YYYY-MM-DD");
              }
              return "";
            },
          },
          // {
          //   prop: "relEndTime",
          //   lable: this.$lange == "en" ? "Actual Emd" : "实际结束",
          //   minWidth: 100,
          //   render: (row) => {
          //     return moment(row.relEndTime).format("YYYY-MM-DD");
          //   },
          // },
          {
            prop: "expatriateOrder.workOrder.customer.customerName",
            lable: this.$lange == "en" ? "Company" : "公司",
            minWidth: 160,
          },
          {
            prop: "expatriateOrder.adminName",
            lable: this.$lange == "en" ? "Requested by" : "申请人",
            minWidth: 120,
          },
          {
            prop: "expatriateOrder.createTime",
            lable: this.$lange == "en" ? "Create at " : "创建时间",
            minWidth: 100,
            render: (row) => {
              return moment(row.expatriateOrder.createTime).format(
                "YYYY-MM-DD"
              );
            },
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Operation" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "Description" : "详情",
            check: (row) => {
              // return row.status === 1;
              return true;
            },
            click: (row) => {
              this.newWindow({
                url: "/admin/order/expatriate/des?id=" + row.expatriateOrder.id,
                name: "外派订单详情",
              });
              // this.detailsId = row.expatriateOrder.id;
              // this.detailsDialog = true;
              // this.isEditV2 = row.expatriateOrder.isHandle;
            },
          },
          {
            name: this.$lange == "en" ? "Handle" : "处理",
            check: (row) => {
              // let res = true;
              // if (
              //   row.expatriateOrder.status === 4 ||
              //   row.expatriateOrder.isHandle !== true
              // ) {
              //   res = false;
              // }
              return row.expatriateOrder.isHandle;
            },
            click: (row) => {
              this.newWindow({
                url: "/admin/order/expatriate/des?id=" + row.expatriateOrder.id,
                name: "外派订单详情",
              });
              // this.detailsId = row.expatriateOrder.id;
              // this.isEditV2 = row.expatriateOrder.isHandle;
              // this.detailsDialog = true;
            },
          },
        ],
      },
      referTable: -1,
      tableParams: {
        workOrderId: "",
        jobId: "",
        status: "",
        geCreateTime: "",
        leCreateTime: "",
      },
      tableParams2: {
        workOrderId: "",
        jobId: "",
        status: "",
        geCreateTime: "",
        leCreateTime: "",
      },
      tableParamsMe: {
        jobId: "",
        status: "",
        queryType: 1,
      },
      user: {},
      seletcTime: [],
    };
  },
  components: {
    ExpartiateDescriptionView,
    ExpartiateDescriptionViewV2,
  },
  methods: {
    timeChange(e) {
      if (e) {
        this.tableParams.geCreateTime = e[0];
        this.tableParams.leCreateTime = e[1];
      } else {
        this.tableParams.geCreateTime = "";
        this.tableParams.leCreateTime = "";
      }
    },
    exportData() {
      let text = "?appId=fosber";
      for (const key in this.tableParams) {
        if (
          this.tableParams[key] !== "" &&
          this.tableParams[key] !== undefined
        ) {
          text += "&" + key + "=" + this.tableParams[key];
        }
      }
      // console.log(text)
      window.open("/admin/fsb/expatriate/expatriateOrderExport" + text);
    },
    dialogClose() {
      if (this.isEditV2) {
        this.referTable = new Date().getTime();
      }
    },
    search() {
      this.tableParams2 = { ...this.tableParams };
    },
  },
  mounted() {
    // this.ccRequest
    //   .do("admin/fsb/user/query", { pageSize: 2000 }, "GET")
    //   .then((res) => {
    //     this.user = res;
    //   });
    //engineer 工程师，projectManager 项目经理，accessoriesSpecialist 配件专员，technicalSupport 技术支持工程师 ，afterSalesManager  售后经理
    let api = `admin/fsb/work/order/queryHandlerUser?pageSize=999&isAsc=true`;
    this.ccRequest
      .do(
        api,
        ["accessoriesSpecialist", "projectManager", "technicalSupport"],
        "POSTJSON"
      )
      .then((res) => {
        this.user = res;
      });
  },
};
</script>
<style >
.order-expartiate .el-dialog__body {
  padding: 10px 20px 30px 20px;
}
</style>
<style scoped lang="scss">
.order-expartiate {
  .title {
    padding: 20px;
    background: #ffffff;
    margin-bottom: 5px;
    justify-content: flex-start;

    > * {
      margin-right: 20px;
    }
  }
}
</style>
